<template>
  <v-container fluid grid-list-xl page>
    <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.title"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>

    </v-layout>

      <v-card class="elevation-2">
        <v-card-title class="headline">Securyty API for integration</v-card-title>
        <v-card-text>There are three ways to integrate Securyty in your current workflows. In the three scenarios you will get all the information required of the signature process, like events and different status updates for real-time updates and reporting.</v-card-text>
      </v-card>

      <v-card>
        <v-card-title class="purple lighten-2">
          <h2 class="display-1 white--text font-weight-light"></h2>
        </v-card-title>
        <v-container>
          <v-layout>
            <v-flex xs10>
              Send us your contact details and we´ll send you detailed information
            </v-flex>
            <v-flex xs2>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="80"
      :rules="nameRules"
      label="Name"
      required
    ></v-text-field>

    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="E-mail"
      required
    ></v-text-field>

    <v-text-field
      v-model="description"
      label="Tell us what you need "
      required
    ></v-text-field>

    <v-checkbox
      v-model="checkbox"
      :rules="[v => !!v || 'You must agree to continue!']"
      label="Do you agree?"
      required
    ></v-checkbox>

    <v-btn
      :disabled="!valid"
      color="success"
      class="mr-4"
      @click="submitContactInfo"
    >
      Send 
    </v-btn>

    <v-btn
      color="error"
      class="mr-4"
      @click="reset"
    >
      Reset Form
    </v-btn>

  </v-form>


<v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Thank you</v-card-title>

        <v-card-text>
          We have received your request. We´ll be back to you soon.
          
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>



          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
//import CreateSignPage from "./CreateSignPage";
//import firebase from "firebase";

export default {
  components: {
//    CreateSignPage
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isCreateSign: false,
      page: {
        title: "API & Integration",
        headline: "Using Securyty in your apps",
        description: `Using Securyty from your apps`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 80) || 'Name must be less than 80 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,

      checkbox: false,
      dialog: false,

    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      this.isCreateSign = true;
    },
    submitContactInfo () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
        var contact ={
          "name": this.name,
          "email" : this.email,
          "description" : this.description,
          "state" : "RECEIVED"
        }
        const self = this;
        var d = new Date();
        var n = d.getTime();
        this.$db.collection("contacts").doc("C" + n).set(contact).then(function() {
          console.log("Document successfully written!");
          self.dialog = true;
        });
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  }
};
</script>
